import { useTranslation } from 'react-i18next';
import { AdvancedSection } from '@/core/AdvancedParameters.atom';
import { FormulaItemTable } from '@/tools/formula/FormulaItemTable.atom';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { FormulaItemTableOption } from '@/tools/formula/FormulaItemTable.atom';

export interface FormulaItemTableIF extends ValidatingFormComponent<string> {
  component: 'FormulaItemTableFormComponent';
  options: FormulaItemTableOption[];
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  collapseLabel?: string;
  textEditable?: boolean;
  onTextChange?: (newValue: string, original: FormulaItemTableOption) => void;
  onEditClick?: (key: string) => void;
  onRemoveClick?: (key: string) => void;
  onAdditionalIconClick?: (key: string) => void;
  additionalIcon?: string;
  additionalIconTooltip?: string;
  onSecondaryIconClick?: (key: string) => void;
  secondaryIcon?: string;
  secondaryIconTooltip?: string;
  hasErrors?: boolean;
  newLabel?: string;
}

export const FormulaItemTableFormComponent = (props: FormulaItemTableIF) => {
  const { t } = useTranslation();

  const {
    options,
    extraClassNames,
    collapsible,
    defaultCollapsed = false,
    collapseLabel,
    tooltip,
    tooltipPlacement,
    tooltipDelay,
    testId,
    wrapperClassNames,
    textEditable,
    onTextChange,
    onEditClick,
    onRemoveClick,
    onAdditionalIconClick,
    additionalIcon,
    additionalIconTooltip,
    onSecondaryIconClick,
    secondaryIcon,
    secondaryIconTooltip,
    hasErrors = false,
    newLabel,
  } = props;

  const expandSection = hasErrors || !defaultCollapsed;

  const formulaItemTable = (
    <span className={extraClassNames} data-testid={testId}>
      <FormulaItemTable
        options={options}
        onEditClick={onEditClick}
        onRemoveClick={onRemoveClick}
        onAdditionalIconClick={onAdditionalIconClick}
        additionalIcon={additionalIcon}
        additionalIconTooltip={additionalIconTooltip}
        onSecondaryIconClick={onSecondaryIconClick}
        secondaryIcon={secondaryIcon}
        secondaryIconTooltip={secondaryIconTooltip}
        testId={testId}
        onTextChange={onTextChange}
        textEditable={textEditable}
        hasErrors={hasErrors}
        newLabel={newLabel}
      />
    </span>
  );

  const content = collapsible ? (
    <div data-testid={`${testId}-collapsible`} className={wrapperClassNames}>
      <AdvancedSection
        collapsed={defaultCollapsed}
        alternateName={collapseLabel}
        t={t}
        tooltip={tooltip}
        tooltipPlacement={tooltipPlacement}
        expandSection={expandSection}
        tooltipDelay={tooltipDelay}>
        {formulaItemTable}
      </AdvancedSection>
    </div>
  ) : (
    formulaItemTable
  );

  return <> {content} </>;
};
